import React, { FC } from 'react';
import styled from 'styled-components';
import { Dialog, DialogFooterButton, DialogWindow } from './Dialogs';
import { T } from '../../Helpers';
import { useZakeke } from '@zakeke/zakeke-configurator-react';
import { QuantityContainer } from '../layouts/LayoutStyled';
import NumericInput from '../layouts/NumericInput';
import { ProductQuantityRule } from '@zakeke/zakeke-configurator-react';

const QuantityDialogWindow = styled(DialogWindow)`
	max-width: unset;
	display: flex;
	flex-direction: column;
`;

const QuantityDialog: FC<{ quantityRule: ProductQuantityRule; onClick: () => void }> = ({ quantityRule, onClick }) => {
	const { isSceneLoading, setQuantity, quantity, translations } = useZakeke();
	const [quantityValue, setQuantityValue] = React.useState(
		quantityRule && quantityRule?.minQuantity ? quantityRule.minQuantity : quantity
	);

	const staticsVals = translations?.statics;

	React.useEffect(() => {
		const delayInputTimeoutId = setTimeout(() => {
			if (!isSceneLoading) {
				if (quantityRule && quantityRule?.minQuantity && quantityValue < quantityRule?.minQuantity) {
					setQuantityValue(quantityRule.minQuantity);
				} else if (quantityRule && quantityRule?.maxQuantity && quantityValue > quantityRule?.maxQuantity) {
					setQuantityValue(quantityRule.maxQuantity);
				} else setQuantityValue(quantityValue);
			}
		}, 600);
		return () => clearTimeout(delayInputTimeoutId);
	}, [quantityValue, isSceneLoading, quantityRule]);

	return (
		<Dialog windowDecorator={QuantityDialogWindow} alignButtons={'center'}>
			<QuantityContainer>
				<label>{T._d('Quantity')}</label>
				<NumericInput
					value={quantityValue}
					readOnly={quantityRule && (quantityRule.step === null || quantityRule.step === 0) ? false : true}
					onChange={(e: any) => {
						if (e.currentTarget.value === '') setQuantityValue(quantityRule?.minQuantity ?? 1);
						else setQuantityValue(parseInt(e.currentTarget.value));
					}}
					min={
						quantityRule.minQuantity != null
							? Math.max(quantityRule.step || 1, quantityRule.minQuantity)
							: quantityRule.step || 1
					}
					max={quantityRule.maxQuantity != null ? quantityRule.maxQuantity : undefined}
					step={quantityRule.step != null ? quantityRule.step : 1}
				/>
			</QuantityContainer>
			<DialogFooterButton
				primary
				isFullWidth
				onClick={() => {
					if (quantityRule) setQuantity(quantityValue);
					onClick();
				}}
			>
				{staticsVals?.get('Add to cart')}
			</DialogFooterButton>
		</Dialog>
	);
};

export default QuantityDialog;